var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as THREE from 'three';
import * as TextCreation from './TextCreation';
import { global } from '../../core/GlobalState';
import { OrbFactory } from '../../orbs/OrbFactory';
import { OrbTypes } from '../../orbs/OrbTypes';
export function addTextDemoGallery(scene) {
    return __awaiter(this, void 0, void 0, function* () {
        const base = new THREE.Vector3(0, 80, 0);
        const spacing = 400;
        // 1. Flat sprite
        scene.add(TextCreation.createTextSprite("Flat Sprite", 2, base.clone().add(new THREE.Vector3(0, 0, spacing * 1))));
        // 2. Billboarded text (same as normal sprite)
        scene.add(TextCreation.createTextSprite("Billboarded", 2, base.clone().add(new THREE.Vector3(0, 0, spacing * 2))));
        // 3. Tilted sprite
        const tilted = TextCreation.createTextSprite("Tilted", 2, base.clone().add(new THREE.Vector3(0, 0, spacing * 3)));
        tilted.rotation.set(Math.PI / 6, Math.PI / 4, 0);
        scene.add(tilted);
        // 4. Curved text (tighter arc)
        const arcCenter = base.clone().add(new THREE.Vector3(0, 0, spacing * 4));
        const arcLetters = TextCreation.createTextCurve("Curved!", arcCenter, 60, 1.5, Math.PI);
        arcLetters.forEach(s => scene.add(s));
        // 5. 3D Text Mesh
        const meshText = yield TextCreation.createTextMesh("3D Text", base.clone().add(new THREE.Vector3(0, 0, spacing * 4)));
        scene.add(meshText);
        // 6. Text + Transparent Panel
        const panelText = yield TextCreation.createTextWithPanel("Panel + Text", 20, base.clone().add(new THREE.Vector3(0, 0, spacing * 5)));
        scene.add(panelText);
        // 7. Rainbow Letters
        const rainbowSprites = TextCreation.createRainbowText("RAINBOW", base.clone().add(new THREE.Vector3(0, 0, spacing * 6)), 2, 40);
        rainbowSprites.forEach(s => scene.add(s));
        // 8. Directional Facing Text
        const facing = TextCreation.createTextSprite("→ Rainbow", 2, base.clone().add(new THREE.Vector3(0, 0, spacing * 7)));
        facing.lookAt(new THREE.Vector3(-10000, 3000, 3000));
        scene.add(facing);
        // 9. Spiral Text (tighter spiral)
        const spiralCenter = base.clone().add(new THREE.Vector3(0, 0, spacing * 8));
        const spiral = "SPIRAL";
        for (let i = 0; i < spiral.length; i++) {
            const angle = i * 0.7;
            const r = 14 * i;
            const x = Math.cos(angle) * r;
            const z = Math.sin(angle) * r;
            const pos = spiralCenter.clone().add(new THREE.Vector3(x, 0, z));
            const sprite = TextCreation.createTextSprite(spiral[i], 1.5, pos);
            sprite.lookAt(global.camera.position);
            scene.add(sprite);
        }
    });
}
//This might be broken atm, not important
export function createMiniOrbGallery(scene, startPos = new THREE.Vector3(-700, 100, -900), spacing = 150, columns = 10) {
    const allTypes = Object.keys(OrbTypes);
    console.log("Debugging why mini orbs don't show up in prod:", allTypes);
    allTypes.forEach((orbType, index) => {
        const orb = OrbFactory.createMiniOrbByType(orbType, orbType);
        if (!orb)
            return;
        const row = Math.floor(index / columns);
        const col = index % columns;
        const pos = startPos.clone().add(new THREE.Vector3(col * spacing, // x → horizontal spacing
        row * spacing, 0 // z → flat wall
        ));
        orb.setPosition(pos);
        orb.addToScene(scene);
    });
}
export function shapeTests(scene) {
    const shapeTestKeys = Object.keys(OrbTypes).filter(k => k.startsWith('SHAPE_TEST_'));
    const startPosition = new THREE.Vector3(-8000, 1000, -3000);
    const spacing = 600;
    shapeTestKeys.forEach((key, index) => {
        const orb = OrbFactory.createOrbByType(key, key.replace('SHAPE_TEST_', ''));
        const position = startPosition.clone().add(new THREE.Vector3(0, index * spacing, 0));
        orb.setPosition(position);
        orb.addToScene(scene);
    });
}
